<template>
  <div>
    <h2 style="margin-bottom: 16px;">{{ id ? '编辑' : '发布' }}二手信息</h2>
    <el-tabs type="border-card">
      <el-tab-pane label="二手详情">
        <el-form :model="form" label-width="150px" style="max-width: 620px;">
          <el-form-item label="物品图片">
            <el-upload action="#" :show-file-list="false" :before-upload="beforeUpload">
              <img v-if="form.oldstuff_img" :src="form.oldstuff_img" style="width: 160px; height: 120px; object-fit: cover; border-radius: 4px; display: block;" />
              <i v-else class="el-icon-plus" style="width: 160px; height: 120px; border: 1px dashed #d9d9d9; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center; font-size: 28px; color: #8c939d;"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="名称">
            <el-input v-model="form.oldstuff_name"></el-input>
          </el-form-item>
          <el-form-item label="价格">
            <el-input v-model="form.oldstuff_price"></el-input>
          </el-form-item>
          <el-form-item label="分类">
            <el-radio-group v-model="form.oldstuff_lable">
              <el-radio v-for="item in lable" :key="item" :label="item">{{ item }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="物品详情描述">
            <rich-editor v-model="form.oldstuff_content"></rich-editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确定</el-button>
            <el-button @click="$router.push('/admin/createoldstufflist')">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="预想购买">
        <el-table :data="joinslist" border>
          <el-table-column label="创建日期" width="170">
            <template slot-scope="scope">{{ scope.row.jions_createtime | dataFormat }}</template>
          </el-table-column>
          <el-table-column label="联系方式" prop="describe"></el-table-column>
          <el-table-column label="报价" prop="name"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import richEditor from '@/components/editor.vue'
import { getLable, createOldstuff, updateOldstuff, getOldstuffDetails, getMyJoins } from '@/api'

export default {
  name: 'CreateOldstuff',
  components: { richEditor },
  props: { id: { type: String, default: '' } },
  data() {
    return {
      lable: [],
      joinslist: [],
      form: { oldstuff_img: '', oldstuff_name: '', oldstuff_price: '', oldstuff_lable: '', oldstuff_content: '' }
    }
  },
  created() {
    getLable('二手分类').then((res) => {
      this.lable = JSON.parse(res.data[0].lable) || []
    })
    if (this.id) {
      getOldstuffDetails(this.id).then((res) => {
        const d = res.data || {}
        this.form = { oldstuff_img: d.oldstuff_img, oldstuff_name: d.oldstuff_name, oldstuff_price: d.oldstuff_price, oldstuff_lable: d.oldstuff_lable, oldstuff_content: d.oldstuff_content }
      })
      getMyJoins(this.id).then((res) => {
        this.joinslist = res.data || []
      })
    }
  },
  methods: {
    beforeUpload(file) {
      this.form.oldstuff_img = URL.createObjectURL(file)
      return false
    },
    onSubmit() {
      if (!this.form.oldstuff_name || !this.form.oldstuff_price) {
        this.$message.error('请填写名称和价格')
        return
      }
      if (this.id) {
        updateOldstuff({ ...this.form, id: this.id }).then((res) => {
          if (res.state.type === 'SUCCESS') {
            this.$message.success('修改成功')
            this.$router.push('/admin/createoldstufflist')
          }
        })
      } else {
        createOldstuff(this.form).then((res) => {
          if (res.state.type === 'SUCCESS') {
            this.$message.success('发布成功，等待审核')
            this.$router.push('/admin/createoldstufflist')
          }
        })
      }
    }
  }
}
</script>
